import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { C } from '../data/constants.js';

interface ActionBtnProps {
  icon?: LucideIcon;
  label: string;
  accent?: boolean;
  onClick?: () => void;
  color?: string;
}

export function ActionBtn({
  icon: Icon,
  label,
  accent,
  onClick,
  color,
}: ActionBtnProps): React.ReactElement {
  const c = color || C.accent;
  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '8px 14px',
        borderRadius: 10,
        border: '1px solid',
        borderColor: accent ? `${c}40` : 'rgba(255,255,255,0.08)',
        background: accent ? `${c}14` : 'rgba(255,255,255,0.03)',
        color: accent ? c : C.textMid,
        fontSize: 12,
        fontWeight: 500,
        cursor: 'pointer',
        fontFamily: "'DM Sans', sans-serif",
        transition: 'all 0.2s',
        whiteSpace: 'nowrap',
      }}
    >
      {Icon && <Icon size={14} />}
      {label}
    </button>
  );
}
